import { Flex, Text } from '@chakra-ui/react';
import Button from '~/components/Button';
import { Picture } from '~/components/Picture';
import { convertPxToRems } from '~/utils-ts';

export interface ISearchContentEmptyProps {
  clear?: () => void;
  searchText?: string;
  noFilter?: boolean;
}

export const SearchContentEmpty: React.FC<ISearchContentEmptyProps> = ({
  clear,
  searchText,
  noFilter = false,
}) => {
  return (
    <Flex
      marginTop={6}
      alignContent="center"
      alignItems="center"
      direction="column"
      flex="1 0 100%"
      justifyContent="space-between"
    >
      <Flex
        padding={convertPxToRems(10)}
        direction="column"
        alignItems="center"
        gap={6}
      >
        <Text
          textAlign="center"
          fontSize="3xl"
          lineHeight={convertPxToRems(28)}
          fontWeight={500}
          color="primary.300"
          maxWidth={{ lg: convertPxToRems(700) }}
        >
          {noFilter ? (
            'Content for this Talent is currently unavailable'
          ) : searchText ? (
            <>
              Sorry we could not find any matches for{' '}
              <Text as="span" color="primary.700">
                {searchText?.trim()}
              </Text>
            </>
          ) : (
            'Sorry we could not find any matches with filter(s) applied'
          )}
        </Text>
        <Text
          textAlign="center"
          fontSize="md"
          fontWeight={400}
          lineHeight={convertPxToRems(16)}
          color="primary.500"
        >
          {noFilter
            ? ' Please try again later.'
            : 'Please try searching with another keyword. You can also use # tags. Searching will look into content titles and descriptions.'}
        </Text>
        {clear && <Button onClick={clear}>Reset filter</Button>}
      </Flex>

      {!noFilter ? (
        <Flex>
          <Picture
            sources={[
              {
                media: '(max-width: 767px)',
                srcSet: '/images/content-search/creator.jpg 720w',
              },
              {
                media: '(min-width: 768px)',
                srcSet: `
            /images/content-search/creator.jpg 720w,
            /images/content-search/creator@x2.jpg 1440w,
            /images/content-search/creator@x3.jpg 2160w
        `,
              },
            ]}
            imgProps={{
              alt: 'No results image',
              width: convertPxToRems(385.97),
              height: convertPxToRems(323.74),
            }}
          />
        </Flex>
      ) : null}
    </Flex>
  );
};
